import { render, staticRenderFns } from "./FFInfotip.vue?vue&type=template&id=04c7926d&scoped=true&"
import script from "./FFInfotip.vue?vue&type=script&lang=js&"
export * from "./FFInfotip.vue?vue&type=script&lang=js&"
import style0 from "./FFInfotip.vue?vue&type=style&index=0&id=04c7926d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c7926d",
  null
  
)

export default component.exports